<template>
    <div class="card">
        <div class="card-body p-5">
            <div class="px-3">
                <h6 class="text-uppercase font-size-base text-muted mt-2 border-bottom pb-4 text-center">{{ name }}</h6>
                <div class="pt-1">
                    <div class="navi navi-hover navi-active navi-accent navi-link-rounded font-size-lg font-weight-bold">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavigationGroup',

    props: {
        name: String
    }
}
</script>
